import { createFileRoute } from "@tanstack/react-router";
import StockImport from "@/pages/StockImport";
import { PrivateRoute } from "@/components/shared/PrivateRoute";
import { routeHead } from "@/lib/seo/route-head";

export const Route = createFileRoute("/import-stock/")({
  head: () => routeHead("/import-stock/"),
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <PrivateRoute><StockImport /></PrivateRoute>
  );
}
